<template>
  <div>
    <div class="mainDiv">
      <div class="leftDiv" v-show="upShow">
        <Upload @okfun="getList()" />
      </div>
      <div class="rightDiv" ref="rightDiv" :style="'width:' + upShowRW">
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
          <el-form :inline="true" :model="listQuery">
            <el-form-item>
              <el-button type="info" @click="handleHide">{{ upShow ? '隐藏' : '显示' }}上传面板</el-button>
            </el-form-item>
            <el-form-item>
              <el-input v-model="listQuery.q" placeholder="搜索"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" v-on:click="getList()">查询</el-button>
            </el-form-item>

            <el-form-item style="margin-left: 20px;">
              <el-link type="primary" href="https://mp.weixin.qq.com/s/NhYs51XBuWYvy9uRDXRBkw"
                target="_blank">上传资料操作指南</el-link>
            </el-form-item>
          </el-form>
        </el-col>
        <el-table :data="tableData" v-loading="listLoading" element-loading-text="Loading" border highlight-current-row
          @sort-change="changeSortFun" ref="dataTable">
          <el-table-column label="状态" align="center" width="100px">
            <template slot-scope="{row}">
              <span>{{ row.Stats }}</span>
            </template>
          </el-table-column>
          <el-table-column label="名称" align="left">
            <template slot-scope="{row}">
              <span v-if="row.Status < 1">{{ row.Name }}</span>
              <span v-else-if="row.Sh == 2">{{ row.Name }} <span style='color:red'>(审核未通过)</span></span>
              <a :href="'http://jazpan.com/view/' + row.Id" target="_blank" v-else>
                <img class="flicon" :src="$ApiUrl + '/icon?name=' + row.Extion" />
                {{ row.Name }}
              </a> &nbsp; <a style="font-size:11px;color:red" target="_blank" :href="'http://jazpan.com/user/'+row.Uid" v-if="row.infoMap.pined==true">[置顶]</a>
            </template>
          </el-table-column>
          <el-table-column label="金额" align="center" width="100px">
            <template slot-scope="{row}">
              <span style="color:#f60;font-weight:bold">{{ row.Amounts }}</span>
            </template>
          </el-table-column>
          <el-table-column label="大小" align="center" width="120px">
            <template slot-scope="{row}">
              <span>{{ getFlSize(row.Size) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Pays" label="付款" align="center" width="80px" sortable>
          </el-table-column>
          <el-table-column prop="Downs" label="下载" align="center" width="80px" sortable>
          </el-table-column>
          <el-table-column label="时间" align="center" width="160px">
            <template slot-scope="{row}">
              <span>{{ row.Timestr }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="200px">
            <template slot-scope="{row}">
              <img class="btnQr" src="//static.jazpan.com/img/qrcode.png"
                @click="$refs.qrcoder.show('https://jazpan.com/view/' + row.Id,'https://m.jazpan.com/xcx/qrgoto/file?'+row.Id)" />
              <el-tooltip class="item" effect="dark" content="加入我的文件夹" placement="top">
                <img class="btnQr" src="//static.jazpan.com/img/flbox.png"
                  @click="$refs.boxSelForm.show(null, row.Xid)" />
              </el-tooltip>
              <i class="btnQr el-icon-edit-outline" style="color:#db3939" @click="$refs.fileEdit.show(row)"></i>
              <i class="btnQr el-icon-delete" style="color:#db3939" @click="delFun(row.Xid)"></i>
              <el-tooltip class="item" effect="dark" :content="(row.infoMap.pined==true?'取消置顶':'置顶')+'在个人主页'" placement="top">
              <i class="btnQr el-icon-top" style="color:#db3939" @click="pinUserFun(row.Xid)"></i>
              </el-tooltip>
              <!-- <el-button-group>
                <el-button size="small" type="warning" @click="$refs.fileEdit.show(row)">编辑</el-button>
                <el-button size="small" type="danger" @click="delFun(row.Xid)">删除</el-button>
              </el-button-group> -->
            </template>
          </el-table-column>
        </el-table>

        <div style="text-align:right;margin-top:50px;">
          <el-pagination background layout="prev, pager, next" @current-change="getList" :current-page="pgpage"
            :page-count="pgpages">
          </el-pagination>
        </div>
      </div>
      <FileEdit ref="fileEdit" @submitOK="getList()" />
      <BoxSelForm ref="boxSelForm" @submitOK="getList()" />
      <Qrcode ref="qrcoder" :showtips="true" />
    </div>
  </div>
</template>

<script>
import util from '@/common/js/util'
import FileEdit from './FileEdit';
import BoxSelForm from './BoxSelForm';
import Qrcode from './Qrcode';
import Upload from './Upload';
export default {
  components: { FileEdit, BoxSelForm, Qrcode, Upload },
  data () {
    return {
      upShow: true,
      upShowRW: 'auto',
      listLoading: false,
      pgpage: 1,
      pgpages: 1,
      listQuery: {
        q: '',
        page: 1
      },
      tableData: []
    }
  }, mounted () {
    this.getList();
    this.upShowRW = this.$refs.rightDiv.clientWidth + 'px';
  }, methods: {
    getFlSize: util.getFlSize,
    getList (pg) {
      this.listLoading = true;
      this.listQuery.page = pg || this.pgpage;
      this.$post('/user/fls', this.listQuery).then(res => {
        console.log('fls:', res);
        this.listLoading = false;
        this.pgpage = res.data.Page;
        this.pgpages = res.data.Pages;
        this.tableData = res.data.Data;
        // this.$message('退出成功');
      }).catch(err => {
        this.listLoading = false;
        this.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    }, delFun (xid) {
      this.$confirm('确定要永久删除此文件吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.$post('/user/fldel', { xid: xid }).then(res => {
          this.$message('删除成功');
          this.getList();
        }).catch(err => {
          this.$message({
            message: err.response ? err.response.data || '服务器错误' : '网络错误',
            type: 'error'
          });
        });
      });
    }, pinUserFun (xid) {
      this.$confirm('确定置顶该文件吗? (置顶后可以到个人主页查看)', '提示', {
        type: 'warning'
      }).then(() => {
        this.$post('/user/flpin', { typ:1,xid: xid }).then(res => {
          this.$message('操作成功');
          this.getList();
        }).catch(err => {
          this.$message({
            message: err.response ? err.response.data || '服务器错误' : '网络错误',
            type: 'error'
          });
        });
      });
    }, handleHide () {
      this.upShow = !this.upShow;
      this.$refs.dataTable.doLayout();
    }, changeSortFun (e) {
      console.log('changeSortFun:', e);
      if (e.order) {
        this.listQuery.sort = {};
        this.listQuery.sort[e.prop] = e.order == "ascending" ? 1 : 2
      } else {
        this.listQuery.sort = null;
      }
      this.getList();
    }
  }
}
</script>

<style scoped lang="scss">
.mainDiv {
  display: flex;
  margin-top: 20px;
  clear: both;

  .leftDiv {
    width: 350px;
    margin-top: 30px;
    margin-right: 40px;
  }

  .rightDiv {
    flex: 1;
  }
}
</style>


// WEBPACK FOOTER //
// FileList.vue?1d6a3f31